import React, { FunctionComponent } from 'react'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type PrimaryButtonProps = Omit<BaseButtonProps, 'buttonType'>

export const PrimaryButton: FunctionComponent<PrimaryButtonProps> = (props) => {
  return <BaseButton {...props} buttonType={ButtonType.PRIMARY} />
}
